import HttpStatus from 'exceptions/httpStatus';
import each from 'lodash/each';

/**
 * Check SEO URL and returned data, and:
 *  * Throws 404 if no data found
 *  * Throws 301 redirect, if URL doesn't match canonical
 *    URL, which builder returns
 * @param wait - data, which we will wait
 * @param builder - link builder for this page
 * @return {{$check: {$wait: [null], $callback: chk}}} - preloader's config
 *
 * Usage:
 *
 * // Preload config
 * const config = {
 *   data: [DataProvider.preload, { url: 'path/to/data...'}]
 *   ...dataCheck('data', dataBuilder)
 * }
 */
export default function (wait, builder) {
  const chk = {
    $wait: [wait],
    $callback: function chk(data, routeProps) {
      const rec = data[wait].data[0];
      if (!rec) {
        return {
          status: [() => Promise.resolve({ error: true, code: 404 })]
        };
      }
      const link = builder({ ...routeProps.params, ...rec });

      // If link builder returns null
      if (!link) {
        return {
          status: [() => Promise.resolve({ error: true, code: 404 })]
        };
      }

      // Check for link correct, and redirect if needed
      if (routeProps.location.pathname !== link.href) {
        if (__CLIENT__) {
          routeProps.router.push(link.href);
        } else {
          throw new HttpStatus(301, link.href);
        }
      }
      return {
        status: [() => Promise.resolve({ error: false })]
      };
    }
  };
  return { $check: chk };
}

/**
 * Simple check for data exists. Can wait and check multiple preloads
 * @param wait
 */
export function simpleCheck(wait) {
  const chk = {
    $wait: wait,
    $callback: function chk(data) {
      let found = true;
      each(wait, (item) => {
        if ((typeof data[item].data !== 'undefined') && !data[item].data[0]) {
          found = false;
        }
      });
      if (!found) {
        return {
          status: [() => Promise.resolve({ error: true, code: 404 })]
        };
      }
      return {
        status: [() => Promise.resolve({ error: false })]
      };
    }
  };
  return { $check: chk };
}
